import format from 'date-fns/format';
import startOfYear from 'date-fns/startOfYear';
import { API_DATE_FORMAT } from '@/lib/constants/common';
import translate from '@/lib/intl/translate';

export const START_OF_1900_API_FORMAT = '1900-01-01';
export const START_OF_YTD_YEAR = startOfYear(new Date());
export const START_OF_YTD_YEAR_API_FORMAT = format(
  START_OF_YTD_YEAR,
  API_DATE_FORMAT,
);
export const TODAY = new Date();
export const TODAY_API_FORMAT = format(TODAY, API_DATE_FORMAT);

// We're considering "all time" as 1900/01/01. Trying to do this more simply
// with `new Date('1900-01-01')` introduces time zone issues where it will
// render to users in the US as 1899/12/31, so we want to safely set this in the
// year 1900 and let date-fns adjust according to local timezone.
export const BEGINNING_OF_TIME = startOfYear(new Date('1900-01-02'));

function validateRequiredDate(value) {
  return !!value || translate('REQUIRED');
}

export const REQUIRED_DATE_RULES = {
  validate: { required: validateRequiredDate },
};
